document.addEventListener('DOMContentLoaded', () => {
  const menuBtn = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (menuBtn && nav) menuBtn.addEventListener('click', () => {
    const isOpen = nav.toggleAttribute('data-open');
    menuBtn.setAttribute('aria-expanded', String(isOpen));
  });

  initSizeFinders(document);
  initLemmoProduct(document);
  initMeasurementSections(document);
  initCategoryCarousels(document);
});

function parseJsonScript(root, selector) {
  const node = root.querySelector(selector);
  if (!node) return [];
  try { return JSON.parse(node.textContent); } catch (_) { return []; }
}

function formatRange(min, max) {
  if (min == null || max == null) return '–';
  return `${formatMeasurement(min)}–${formatMeasurement(max)} cm`;
}

function formatMeasurement(value) {
  const number = Number(value);
  return Number.isFinite(number)
    ? new Intl.NumberFormat('de-DE', {maximumFractionDigits: 2}).format(number)
    : value;
}

function initSizeFinders(root = document) {
  root.querySelectorAll('[data-size-finder]').forEach((finder) => {
    if (finder.dataset.initialized === 'true') return;
    finder.dataset.initialized = 'true';

    const section = finder.closest('section');
    const catalog = parseJsonScript(section || finder, '[data-size-catalog]');
    const form = finder.querySelector('[data-size-form]');
    const result = finder.querySelector('[data-size-result]');
    const matchesNode = finder.querySelector('[data-size-matches]');
    if (!form || !result || !matchesNode) return;

    const measurements = form.querySelector('[data-size-measurements]');
    const sideA = form.querySelector('[data-size-side-a]');
    const sideB = form.querySelector('[data-size-side-b]');
    const swap = form.querySelector('[data-size-swap]');
    const measurementNote = form.querySelector('[data-size-measurement-note]');
    const submit = form.querySelector('button[type="submit"]');
    const typeOptions = {
      'eckeinstieg': {twoSides: true, allowSwap: true},
      'seitenglas-tuer': {twoSides: true, allowSwap: true},
      'duschwand-glaswand': {twoSides: false, labelA: 'Breite'},
      'nischentuer-duschtuer': {twoSides: false, labelA: 'Nischenbreite', showMeasurementNote: true},
      'u-dusche': {twoSides: true, labelA: 'Türseite', labelB: 'Seitenglas', fitOrder: 'b-a'}
    };

    const updateFormForType = () => {
      const type = form.elements.shower_type?.value;
      const config = typeOptions[type];
      if (!config) return;
      measurements.hidden = false;
      sideB.hidden = !config.twoSides;
      swap.hidden = !config.allowSwap;
      measurementNote.hidden = !config.showMeasurementNote;
      form.elements.side_b.disabled = !config.twoSides;
      form.elements.side_b.required = config.twoSides;
      if (!config.twoSides) form.elements.side_b.value = '';
      sideA.childNodes[0].textContent = config.labelA || 'Seite A';
      sideB.childNodes[0].textContent = config.labelB || 'Seite B';
      submit.disabled = false;
    };

    form.querySelectorAll('input[name="shower_type"]').forEach((input) => input.addEventListener('change', updateFormForType));

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const showerType = form.elements.shower_type?.value;
      const typeConfig = typeOptions[showerType];
      const a = parseFloat(form.elements.side_a?.value || '');
      const rawB = form.elements.side_b?.value || '';
      const b = rawB === '' ? null : parseFloat(rawB);
      const allowSwap = Boolean(typeConfig?.allowSwap);

      if (!typeConfig || Number.isNaN(a) || (typeConfig.twoSides && (b === null || Number.isNaN(b)))) {
        result.innerHTML = '<strong>Bitte gültige Maße eingeben.</strong><span>Verwenden Sie Zentimeter, z. B. 88 und 73.</span>';
        matchesNode.innerHTML = '';
        return;
      }

      const typeCatalog = catalog.filter((item) => item.type === showerType);
      if (!typeCatalog.length) {
        result.innerHTML = '<strong>Noch keine Produktdaten hinterlegt.</strong><span>Wählen Sie im Theme-Editor eine Collection und pflegen Sie die Variant-Metafields.</span>';
        matchesNode.innerHTML = '';
        return;
      }

      const fits = (item, x, y) => {
        const aFits = x >= Number(item.minA) && x <= Number(item.maxA);
        if (!aFits) return false;
        if (item.minB == null || item.maxB == null) return y == null;
        return y != null && y >= Number(item.minB) && y <= Number(item.maxB);
      };

      const matches = typeCatalog
        .map((item) => {
          const catalogA = typeConfig?.fitOrder === 'b-a' ? b : a;
          const catalogB = typeConfig?.fitOrder === 'b-a' ? a : b;
          const direct = fits(item, catalogA, catalogB);
          const swapped = !direct && allowSwap && b != null && fits(item, catalogB, catalogA);
          return direct || swapped ? {...item, swapped} : null;
        })
        .filter(Boolean)
        .sort((x, y) => Number(y.available) - Number(x.available));

      if (!matches.length) {
        result.innerHTML = '<strong>Keine direkte Übereinstimmung gefunden.</strong><span>Prüfen Sie die Messpunkte oder kontaktieren Sie uns – oft gibt es eine passende Alternative.</span>';
        matchesNode.innerHTML = '';
        return;
      }

      result.innerHTML = `<strong>${matches.length} passende ${matches.length === 1 ? 'Variante' : 'Varianten'} gefunden.</strong><span>Basis sind die tatsächlichen Einbaubereiche, nicht nur die Nenngröße.</span>`;
      matchesNode.innerHTML = matches.slice(0, 6).map((item) => `
        <a class="size-match" href="${item.url}">
          <div class="size-match__image">${item.image ? `<img src="${item.image}" alt="" loading="lazy">` : ''}</div>
          <div class="size-match__body">
            <span class="size-match__kicker">${item.available ? 'Sofort auswählbar' : 'Derzeit nicht verfügbar'}</span>
            <strong>${item.productTitle}</strong>
            <span>${item.variantTitle}</span>
            <span>${showerType === 'u-dusche' ? `Türseite: ${formatMeasurement(item.minB)}–${formatMeasurement(item.maxB)} cm · Seitenglas: ${formatMeasurement(item.minA)}–${formatMeasurement(item.maxA)} cm` : `Einbaumaß A: ${formatMeasurement(item.minA)}–${formatMeasurement(item.maxA)} cm${item.minB != null ? ` · B: ${formatMeasurement(item.minB)}–${formatMeasurement(item.maxB)} cm` : ''}`}</span>
            ${item.swapped ? '<span class="size-match__swap">A/B gedreht passend</span>' : ''}
            <b>${item.price}</b>
          </div>
        </a>`).join('');
    });
  });
}

function initCategoryCarousels(root = document) {
  root.querySelectorAll('[data-category-carousel]').forEach((carousel) => {
    if (carousel.dataset.initialized === 'true') return;
    carousel.dataset.initialized = 'true';

    const track = carousel.querySelector('[data-category-track]');
    const previous = carousel.querySelector('[data-category-prev]');
    const next = carousel.querySelector('[data-category-next]');
    if (!track || !previous || !next) return;

    let isMoving = false;

    const getStep = () => {
      const firstCard = track.querySelector('.category-card');
      if (!firstCard) return 0;
      const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return firstCard.getBoundingClientRect().width + gap;
    };

    const setScrollInstantly = (position) => {
      const savedBehavior = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = position;
      track.style.scrollBehavior = savedBehavior;
    };

    const afterScroll = (callback) => {
      let finished = false;
      const finish = () => {
        if (finished) return;
        finished = true;
        window.clearTimeout(fallback);
        track.removeEventListener('scrollend', finish);
        callback();
      };
      const fallback = window.setTimeout(finish, 650);
      track.addEventListener('scrollend', finish, {once: true});
    };

    const rotate = (direction) => {
      const cards = [...track.querySelectorAll('.category-card')];
      const step = getStep();
      if (isMoving || cards.length < 2 || !step) return;

      isMoving = true;
      previous.disabled = true;
      next.disabled = true;
      const finish = () => {
        isMoving = false;
        previous.disabled = false;
        next.disabled = false;
      };

      if (direction > 0) {
        // Slide to the next card first; then move the old first card to the end
        // and reset the offset without changing the image currently in view.
        track.scrollTo({left: step, behavior: 'smooth'});
        afterScroll(() => {
          track.append(track.querySelector('.category-card'));
          setScrollInstantly(0);
          finish();
        });
      } else {
        // Put the previous card just outside the left edge, then slide it in.
        track.prepend(cards[cards.length - 1]);
        setScrollInstantly(step);
        window.requestAnimationFrame(() => {
          track.scrollTo({left: 0, behavior: 'smooth'});
          afterScroll(finish);
        });
      }
    };

    let autoplayId;
    const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    const stopAutoplay = () => {
      if (!autoplayId) return;
      window.clearInterval(autoplayId);
      autoplayId = undefined;
    };
    const startAutoplay = () => {
      if (reduceMotion || autoplayId) return;
      autoplayId = window.setInterval(() => rotate(1), 5000);
    };

    previous.addEventListener('click', () => { rotate(-1); stopAutoplay(); startAutoplay(); });
    next.addEventListener('click', () => { rotate(1); stopAutoplay(); startAutoplay(); });
    carousel.addEventListener('pointerenter', stopAutoplay);
    carousel.addEventListener('pointerleave', startAutoplay);
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', startAutoplay);
    carousel.addEventListener('touchstart', stopAutoplay, {passive: true});
    carousel.addEventListener('touchend', startAutoplay, {passive: true});
    carousel.addEventListener('touchcancel', startAutoplay, {passive: true});
    startAutoplay();
  });
}

function initLemmoProduct(root = document) {
  root.querySelectorAll('[data-product-section]').forEach((section) => {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    section.querySelectorAll('[data-media-target]').forEach((button) => {
      button.addEventListener('click', () => {
        const id = button.dataset.mediaTarget;
        section.querySelectorAll('[data-media-id]').forEach((item) => item.hidden = item.dataset.mediaId !== id);
        section.querySelectorAll('[data-media-target]').forEach((thumb) => thumb.classList.toggle('is-active', thumb === button));
      });
    });

    const variants = parseJsonScript(section, '[data-product-json]');
    const fitData = parseJsonScript(section, '[data-product-fit-json]');
    const form = section.querySelector('[data-product-form]');
    if (!variants.length || !form) return;

    const fitValue = section.querySelector('[data-product-fit-value]');
    const fitBox = section.querySelector('[data-product-fit-box]');
    const adjustmentRow = section.querySelector('[data-product-adjustment-row]');
    const adjustmentValue = section.querySelector('[data-product-adjustment-value]');
    const priceNode = section.querySelector('[data-product-price]');
    const comparePriceNode = section.querySelector('[data-product-compare]');
    const moneyFormat = section.querySelector('[data-price-wrap]')?.dataset.moneyFormat;

    const formatPrice = (cents) => {
      const value = Number(cents || 0) / 100;
      const formats = {
        amount: new Intl.NumberFormat('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(value),
        amount_no_decimals: new Intl.NumberFormat('en-US', {maximumFractionDigits: 0}).format(value),
        amount_with_comma_separator: new Intl.NumberFormat('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(value),
        amount_no_decimals_with_comma_separator: new Intl.NumberFormat('de-DE', {maximumFractionDigits: 0}).format(value),
        amount_with_apostrophe_separator: new Intl.NumberFormat('de-CH', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(value)
      };
      if (!moneyFormat) return `${formats.amount_with_comma_separator} €`;
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, token) => formats[token] ?? formats.amount_with_comma_separator);
    };

    const updatePrice = (variant) => {
      if (priceNode) priceNode.textContent = formatPrice(variant.price);
      if (!comparePriceNode) return;
      const hasCompareAtPrice = Number(variant.compare_at_price) > Number(variant.price);
      comparePriceNode.hidden = !hasCompareAtPrice;
      comparePriceNode.textContent = hasCompareAtPrice ? formatPrice(variant.compare_at_price) : '';
    };

    const updateFit = (variantId) => {
      if (!fitValue || !fitBox) return;
      const fit = fitData.find((item) => String(item.id) === String(variantId));
      if (!fit || fit.minA == null || fit.maxA == null) {
        fitBox.hidden = true;
        if (adjustmentRow) adjustmentRow.hidden = true;
        return;
      }
      fitBox.hidden = false;
      const reverseFitOrder = section.dataset.fitOrder === 'b-a';
      fitValue.textContent = fit.minB != null && fit.maxB != null
        ? (reverseFitOrder ? `${formatMeasurement(fit.minB)}–${formatMeasurement(fit.maxB)} × ${formatMeasurement(fit.minA)}–${formatMeasurement(fit.maxA)} cm` : `${formatMeasurement(fit.minA)}–${formatMeasurement(fit.maxA)} × ${formatMeasurement(fit.minB)}–${formatMeasurement(fit.maxB)} cm`)
        : `${formatMeasurement(fit.minA)}–${formatMeasurement(fit.maxA)} cm`;
      if (adjustmentRow && adjustmentValue) {
        const rangeA = Number(fit.maxA) - Number(fit.minA);
        const rangeB = fit.minB != null && fit.maxB != null ? Number(fit.maxB) - Number(fit.minB) : null;
        const firstRange = reverseFitOrder && rangeB != null ? rangeB : rangeA;
        const secondRange = reverseFitOrder ? rangeA : rangeB;
        adjustmentValue.textContent = secondRange == null
          ? `${formatMeasurement(firstRange)} cm`
          : firstRange === secondRange
            ? `${formatMeasurement(firstRange)} cm je Seite`
            : `${formatMeasurement(firstRange)} cm × ${formatMeasurement(secondRange)} cm`;
        adjustmentRow.hidden = false;
      }
      document.dispatchEvent(new CustomEvent('lemmo:variant-change', {detail: {variantId}}));
    };

    const updateOptionAvailability = () => {
      const fieldsets = [...section.querySelectorAll('[data-variant-picker] fieldset')];
      const selected = fieldsets.map((fieldset) => fieldset.querySelector('input:checked')?.value);
      fieldsets.forEach((fieldset, index) => {
        fieldset.querySelectorAll('input').forEach((input) => {
          const choices = [...selected];
          choices[index] = input.value;
          const available = variants.some((candidate) => candidate.available && candidate.options.every((option, optionIndex) => option === choices[optionIndex]));
          input.disabled = !available;
          input.closest('.variant-pill')?.classList.toggle('is-sold-out', !available);
          input.closest('.variant-pill')?.setAttribute('aria-disabled', String(!available));
        });
      });
    };

    const updateVariant = () => {
      const selected = [...section.querySelectorAll('[data-variant-picker] fieldset')].map((fieldset) => fieldset.querySelector('input:checked')?.value);
      const variant = variants.find((candidate) => candidate.options.every((option, index) => option === selected[index]));
      if (!variant) return;
      const idInput = form.querySelector('[data-variant-id]');
      if (idInput) idInput.value = variant.id;
      const submit = form.querySelector('[data-add-to-cart]');
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? 'In den Warenkorb' : 'Nicht verfügbar';
      }
      updatePrice(variant);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
      updateFit(variant.id);
      updateOptionAvailability();
    };

    section.querySelectorAll('[data-variant-picker] input').forEach((input) => input.addEventListener('change', updateVariant));
    updateOptionAvailability();
    updateFit(form.querySelector('[data-variant-id]')?.value);
  });
}

function initMeasurementSections(root = document) {
  root.querySelectorAll('[data-measurement-section]').forEach((section) => {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';
    const fitData = parseJsonScript(section, '[data-variant-fit-json]');
    const aNode = section.querySelector('[data-fit-a]');
    const bNode = section.querySelector('[data-fit-b]');
    const bCard = section.querySelector('[data-fit-b-card]');
    const status = section.querySelector('[data-fit-status]');

    const render = (variantId) => {
      const fit = fitData.find((item) => String(item.id) === String(variantId));
      if (!fit || fit.minA == null || fit.maxA == null) {
        section.hidden = true;
        return;
      }
      section.hidden = false;
      const reverseFitOrder = section.dataset.fitOrder === 'b-a';
      if (aNode) aNode.textContent = reverseFitOrder ? formatRange(fit.minB, fit.maxB) : formatRange(fit.minA, fit.maxA);
      if (bNode) bNode.textContent = reverseFitOrder ? formatRange(fit.minA, fit.maxA) : (fit.minB != null ? formatRange(fit.minB, fit.maxB) : 'Nicht erforderlich');
      if (bCard) bCard.hidden = fit.minB == null || fit.maxB == null;
      if (status) status.textContent = 'Diese Werte beziehen sich auf die aktuell ausgewählte Produktvariante.';
    };

    const initialId = new URL(window.location.href).searchParams.get('variant') || document.querySelector('[data-variant-id]')?.value;
    if (initialId) render(initialId);
    document.addEventListener('lemmo:variant-change', (event) => render(event.detail.variantId));
  });
}

document.addEventListener('shopify:section:load', (event) => {
  initSizeFinders(event.target);
  initLemmoProduct(event.target);
  initMeasurementSections(event.target);
  initCategoryCarousels(event.target);
});

// Shopify recommendation sections are fetched after page load to keep the product page lean.
document.querySelectorAll('[data-product-recommendations]').forEach((container) => {
  if (!container.dataset.url) return;
  fetch(container.dataset.url)
    .then((response) => response.text())
    .then((text) => {
      const html = new DOMParser().parseFromString(text, 'text/html');
      const incoming = html.querySelector('[data-product-recommendations]');
      if (incoming && incoming.innerHTML.trim()) container.innerHTML = incoming.innerHTML;
    })
    .catch(() => {});
});

// v0.5 Cart Drawer + collection controls
(() => {
  const drawer = () => document.querySelector('[data-cart-drawer]');
  const openDrawer = () => {
    const el = drawer(); if (!el) return;
    el.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  };
  const closeDrawer = () => {
    const el = drawer(); if (!el) return;
    el.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  };
  const bindDrawer = () => {
    document.querySelectorAll('[data-cart-open]').forEach((el) => {
      if (el.dataset.cartBound) return; el.dataset.cartBound='1';
      el.addEventListener('click',(e)=>{e.preventDefault();openDrawer();});
    });
    const d = drawer(); if (!d || d.dataset.bound) return; d.dataset.bound='1';
    d.querySelectorAll('[data-cart-close]').forEach((el)=>el.addEventListener('click',closeDrawer));
    d.addEventListener('change', async (e) => {
      const input=e.target.closest('[data-cart-qty]'); if(!input) return;
      const line=input.closest('[data-cart-line]'); if(!line) return;
      await updateCartLine(line.dataset.lineKey, Number(input.value));
    });
    d.addEventListener('click', async (e) => {
      const btn=e.target.closest('[data-cart-remove]'); if(!btn) return;
      const line=btn.closest('[data-cart-line]'); if(!line) return;
      await updateCartLine(line.dataset.lineKey,0);
    });
  };
  const refreshCartDrawer = async () => {
    const response = await fetch(`${window.location.pathname}?sections=cart-drawer`);
    const sections = await response.json();
    const current = drawer();
    const doc = new DOMParser().parseFromString(sections['cart-drawer'] || '', 'text/html');
    const incoming = doc.querySelector('[data-cart-drawer]');
    if (current && incoming) current.replaceWith(incoming);
    const cart = await fetch('/cart.js').then(r=>r.json());
    document.querySelectorAll('[data-cart-count]').forEach((n)=>n.textContent=cart.item_count);
    bindDrawer();
    openDrawer();
  };
  const updateCartLine = async (key, quantity) => {
    await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})});
    await refreshCartDrawer();
  };
  document.addEventListener('submit', async (e) => {
    const form=e.target.closest('[data-product-form]'); if(!form) return;
    const submitter=e.submitter;
    if (submitter && submitter.name==='checkout') return;
    e.preventDefault();
    try {
      const res=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
      if(!res.ok) throw new Error('Cart add failed');
      await refreshCartDrawer();
    } catch (_) { form.submit(); }
  });
  document.addEventListener('DOMContentLoaded', bindDrawer);
  document.addEventListener('shopify:section:load', bindDrawer);
})();

(() => {
  const initCollectionControls = (root=document) => {
    root.querySelectorAll('[data-collection-section]').forEach((section)=>{
      if(section.dataset.controlsBound) return; section.dataset.controlsBound='1';
      const panel=section.querySelector('[data-filter-panel]');
      section.querySelector('[data-filter-toggle]')?.addEventListener('click',()=>panel?.classList.add('is-open'));
      section.querySelector('[data-filter-close]')?.addEventListener('click',()=>panel?.classList.remove('is-open'));
      section.querySelector('[data-sort-select]')?.addEventListener('change',(e)=>e.target.form?.submit());
    });
  };
  document.addEventListener('DOMContentLoaded',()=>initCollectionControls());
  document.addEventListener('shopify:section:load',(e)=>initCollectionControls(e.target));
})();
